import { Box, Flex, Text } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { Image } from "@chakra-ui/react";

const StepDesc = ({ active }) => {
  const { t } = useI18n();

  const renderStep = (active, current) => {
    let dom = null;
    if (active > current) {
      dom = (
        <Image
          borderRadius={"24px"}
          w="24px"
          h="24px"
          src="../wwwsite/images/blue_success_ghost.svg"
        />
      );
    } else if (active === current) {
      dom = (
        <Box
          w="24px"
          h="24px"
          bg={active === current ? "blue.100" : "#fff"}
          color={"#fff"}
          lineHeight={"22px"}
          textAlign={"center"}
          fontSize={"12px"}
          borderRadius={"24px"}
          border="1px solid #333BF5"
        >
          {current}
        </Box>
      );
    } else {
      dom = (
        <Box
          w="24px"
          h="24px"
          bg={active === current ? "blue.100" : "#fff"}
          color={"#B3B4C8"}
          lineHeight={"22px"}
          textAlign={"center"}
          fontSize={"12px"}
          borderRadius={"24px"}
          border="1px solid #B3B4C8"
        >
          {current}
        </Box>
      );
    }
    return (
      <Box w="24px" h="24px">
        {dom}
      </Box>
    );
  };

  return (
    <Box
      overflow={"hidden"}
      w={"100%"}
      h={"30px"}
      mb="50px"
      mt="50px"
      position={"relative"}
    >
      <Flex
        justifyContent={"flex-start"}
        alignItems={"center"}
        flexWrap={"nowrap"}
        w="fit-content"
        right={active > 2 ? "0px" : ""}
        position={"absolute"}
      >
        {renderStep(active, 1)}
        <Text
          fontSize={"12px"}
          color={active >= 1 ? "t.100" : "t.50"}
          ml="5px"
          whiteSpace={"nowrap"}
        >
          {t("kuTgfRDYzVZvEHrFtQ")}
        </Text>
        <Box w="24px" h="2px" bg="blue.100" ml="8px" mr="8px"></Box>
        {renderStep(active, 2)}

        <Text
          fontSize={"12px"}
          color={active >= 2 ? "t.100" : "t.50"}
          ml="5px"
          whiteSpace={"nowrap"}
        >
          {t("razdiXXHIkQKbPQTZn")}
        </Text>
        <Box w="24px" h="2px" bg="blue.100" ml="8px" mr="8px"></Box>
        {renderStep(active, 3)}
        <Text
          fontSize={"12px"}
          color={active >= 3 ? "t.100" : "t.50"}
          ml="5px"
          whiteSpace={"nowrap"}
        >
          {t("BNXHKONNlrkDGKwkXt")}
        </Text>
        <Box w="24px" h="2px" bg="blue.100" ml="8px" mr="8px"></Box>
        {renderStep(active, 4)}
        <Text
          fontSize={"12px"}
          color={active >= 3 ? "t.100" : "t.50"}
          ml="5px"
          whiteSpace={"nowrap"}
        >
          {t("nSdDtaHzknwZAXJHzrGP")}
        </Text>
      </Flex>
    </Box>
  );
};

export default StepDesc;
